/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: beta
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * AppsApi - axios parameter creator
 * @export
 */
export const AppsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [APPS] Get PSD2 information for two factor authentication
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Apps: (id_1, formType_1, version_1, authorization_1, ...args_1) => __awaiter(this, [id_1, formType_1, version_1, authorization_1, ...args_1], void 0, function* (id, formType, version, authorization, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInitPsd2Apps', 'id', id);
            // verify required parameter 'formType' is not null or undefined
            assertParamExists('getInitPsd2Apps', 'formType', formType);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getInitPsd2Apps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInitPsd2Apps', 'authorization', authorization);
            const localVarPath = `/restpublic/tech-apps/psd2/tfa/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] verify PSD2 two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeApps: (version_1, authorization_1, body_1, ...args_1) => __awaiter(this, [version_1, authorization_1, body_1, ...args_1], void 0, function* (version, authorization, body, options = {}) {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('postVerifyPsd2CodeApps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postVerifyPsd2CodeApps', 'authorization', authorization);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('postVerifyPsd2CodeApps', 'body', body);
            const localVarPath = `/restpublic/tech-apps/psd2/tfa/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] Send two factor authentication code to a registered user
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeApps: (version_1, authorization_1, ...args_1) => __awaiter(this, [version_1, authorization_1, ...args_1], void 0, function* (version, authorization, options = {}) {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('sendCodeApps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sendCodeApps', 'authorization', authorization);
            const localVarPath = `/restpublic/tech-apps/tfa/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] Send PSD2 two factor authentication code to a registered user
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeApps: (id_1, formType_1, version_1, authorization_1, ...args_1) => __awaiter(this, [id_1, formType_1, version_1, authorization_1, ...args_1], void 0, function* (id, formType, version, authorization, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendPSD2CodeApps', 'id', id);
            // verify required parameter 'formType' is not null or undefined
            assertParamExists('sendPSD2CodeApps', 'formType', formType);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('sendPSD2CodeApps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sendPSD2CodeApps', 'authorization', authorization);
            const localVarPath = `/restpublic/tech-apps/psd2/tfa/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] Setup two factor authentication phone number for a user
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupApps: (version_1, authorization_1, body_1, ...args_1) => __awaiter(this, [version_1, authorization_1, body_1, ...args_1], void 0, function* (version, authorization, body, options = {}) {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('setupApps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('setupApps', 'authorization', authorization);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setupApps', 'body', body);
            const localVarPath = `/restpublic/tech-apps/tfa/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] Check if user is registered
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists: (version_1, authorization_1, ...args_1) => __awaiter(this, [version_1, authorization_1, ...args_1], void 0, function* (version, authorization, options = {}) {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('userExists', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('userExists', 'authorization', authorization);
            const localVarPath = `/restpublic/tech-apps/tfa/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [APPS] Verify two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApps: (version_1, authorization_1, body_1, ...args_1) => __awaiter(this, [version_1, authorization_1, body_1, ...args_1], void 0, function* (version, authorization, body, options = {}) {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('verifyApps', 'version', version);
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verifyApps', 'authorization', authorization);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyApps', 'body', body);
            const localVarPath = `/restpublic/tech-apps/tfa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppsApi - functional programming interface
 * @export
 */
export const AppsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [APPS] Get PSD2 information for two factor authentication
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Apps(id, formType, version, authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInitPsd2Apps(id, formType, version, authorization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] verify PSD2 two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeApps(version, authorization, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postVerifyPsd2CodeApps(version, authorization, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] Send two factor authentication code to a registered user
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeApps(version, authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendCodeApps(version, authorization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] Send PSD2 two factor authentication code to a registered user
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeApps(id, formType, version, authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendPSD2CodeApps(id, formType, version, authorization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] Setup two factor authentication phone number for a user
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupApps(version, authorization, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setupApps(version, authorization, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] Check if user is registered
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(version, authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userExists(version, authorization, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [APPS] Verify two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApps(version, authorization, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyApps(version, authorization, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppsApi - factory interface
 * @export
 */
export const AppsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppsApiFp(configuration);
    return {
        /**
         *
         * @summary [APPS] Get PSD2 information for two factor authentication
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Apps(id, formType, version, authorization, options) {
            return localVarFp.getInitPsd2Apps(id, formType, version, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] verify PSD2 two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeApps(version, authorization, body, options) {
            return localVarFp.postVerifyPsd2CodeApps(version, authorization, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] Send two factor authentication code to a registered user
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeApps(version, authorization, options) {
            return localVarFp.sendCodeApps(version, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] Send PSD2 two factor authentication code to a registered user
         * @param {number} id Payout id
         * @param {string} formType PAYOUT
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeApps(id, formType, version, authorization, options) {
            return localVarFp.sendPSD2CodeApps(id, formType, version, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] Setup two factor authentication phone number for a user
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupApps(version, authorization, body, options) {
            return localVarFp.setupApps(version, authorization, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] Check if user is registered
         * @param {number} version 1
         * @param {string} authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExists(version, authorization, options) {
            return localVarFp.userExists(version, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [APPS] Verify two factor authentication code
         * @param {number} version 1
         * @param {string} authorization
         * @param {TfaVerifyFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyApps(version, authorization, body, options) {
            return localVarFp.verifyApps(version, authorization, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppsApi - object-oriented interface
 * @export
 * @class AppsApi
 * @extends {BaseAPI}
 */
export class AppsApi extends BaseAPI {
    /**
     *
     * @summary [APPS] Get PSD2 information for two factor authentication
     * @param {number} id Payout id
     * @param {string} formType PAYOUT
     * @param {number} version 1
     * @param {string} authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    getInitPsd2Apps(id, formType, version, authorization, options) {
        return AppsApiFp(this.configuration).getInitPsd2Apps(id, formType, version, authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] verify PSD2 two factor authentication code
     * @param {number} version 1
     * @param {string} authorization
     * @param {TfaVerifyRequestBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    postVerifyPsd2CodeApps(version, authorization, body, options) {
        return AppsApiFp(this.configuration).postVerifyPsd2CodeApps(version, authorization, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] Send two factor authentication code to a registered user
     * @param {number} version 1
     * @param {string} authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    sendCodeApps(version, authorization, options) {
        return AppsApiFp(this.configuration).sendCodeApps(version, authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] Send PSD2 two factor authentication code to a registered user
     * @param {number} id Payout id
     * @param {string} formType PAYOUT
     * @param {number} version 1
     * @param {string} authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    sendPSD2CodeApps(id, formType, version, authorization, options) {
        return AppsApiFp(this.configuration).sendPSD2CodeApps(id, formType, version, authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] Setup two factor authentication phone number for a user
     * @param {number} version 1
     * @param {string} authorization
     * @param {TfaSetupFrontRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    setupApps(version, authorization, body, options) {
        return AppsApiFp(this.configuration).setupApps(version, authorization, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] Check if user is registered
     * @param {number} version 1
     * @param {string} authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    userExists(version, authorization, options) {
        return AppsApiFp(this.configuration).userExists(version, authorization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [APPS] Verify two factor authentication code
     * @param {number} version 1
     * @param {string} authorization
     * @param {TfaVerifyFrontRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    verifyApps(version, authorization, body, options) {
        return AppsApiFp(this.configuration).verifyApps(version, authorization, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LoginVerificationApi - axios parameter creator
 * @export
 */
export const LoginVerificationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the phone number snippet and the channel to send the verification code (SMS/CALL).
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initLoginVerification: (token_1, ...args_1) => __awaiter(this, [token_1, ...args_1], void 0, function* (token, options = {}) {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('initLoginVerification', 'token', token);
            const localVarPath = `/restpublic/tech-web/tfa/login/init/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the user\'s label.
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpInitLoginVerification: (token_1, ...args_1) => __awaiter(this, [token_1, ...args_1], void 0, function* (token, options = {}) {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('otpInitLoginVerification', 'token', token);
            const localVarPath = `/restpublic/tech-web/otp/login/init/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {LoginVerificationCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpVerifyLoginVerification: (token_1, body_1, ...args_1) => __awaiter(this, [token_1, body_1, ...args_1], void 0, function* (token, body, options = {}) {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('otpVerifyLoginVerification', 'token', token);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('otpVerifyLoginVerification', 'body', body);
            const localVarPath = `/restpublic/tech-web/otp/login/verify/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send a verification code to the user\'s phone number.
         * @param {LoginVerificationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLoginVerification: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendLoginVerification', 'body', body);
            const localVarPath = `/restpublic/tech-web/tfa/login/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {TfaVerifyWsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyLoginVerification: (token_1, body_1, ...args_1) => __awaiter(this, [token_1, body_1, ...args_1], void 0, function* (token, body, options = {}) {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyLoginVerification', 'token', token);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyLoginVerification', 'body', body);
            const localVarPath = `/restpublic/tech-web/tfa/login/verify/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LoginVerificationApi - functional programming interface
 * @export
 */
export const LoginVerificationApiFp = function (configuration) {
    const localVarAxiosParamCreator = LoginVerificationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the phone number snippet and the channel to send the verification code (SMS/CALL).
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initLoginVerification(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initLoginVerification(token, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the user\'s label.
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpInitLoginVerification(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.otpInitLoginVerification(token, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {LoginVerificationCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpVerifyLoginVerification(token, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.otpVerifyLoginVerification(token, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send a verification code to the user\'s phone number.
         * @param {LoginVerificationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLoginVerification(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendLoginVerification(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {TfaVerifyWsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyLoginVerification(token, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyLoginVerification(token, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LoginVerificationApi - factory interface
 * @export
 */
export const LoginVerificationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LoginVerificationApiFp(configuration);
    return {
        /**
         *
         * @summary Get the phone number snippet and the channel to send the verification code (SMS/CALL).
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initLoginVerification(token, options) {
            return localVarFp.initLoginVerification(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the user\'s label.
         * @param {string} token Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpInitLoginVerification(token, options) {
            return localVarFp.otpInitLoginVerification(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {LoginVerificationCode} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpVerifyLoginVerification(token, body, options) {
            return localVarFp.otpVerifyLoginVerification(token, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send a verification code to the user\'s phone number.
         * @param {LoginVerificationToken} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendLoginVerification(body, options) {
            return localVarFp.sendLoginVerification(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {string} token Token
         * @param {TfaVerifyWsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyLoginVerification(token, body, options) {
            return localVarFp.verifyLoginVerification(token, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LoginVerificationApi - object-oriented interface
 * @export
 * @class LoginVerificationApi
 * @extends {BaseAPI}
 */
export class LoginVerificationApi extends BaseAPI {
    /**
     *
     * @summary Get the phone number snippet and the channel to send the verification code (SMS/CALL).
     * @param {string} token Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginVerificationApi
     */
    initLoginVerification(token, options) {
        return LoginVerificationApiFp(this.configuration).initLoginVerification(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the user\'s label.
     * @param {string} token Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginVerificationApi
     */
    otpInitLoginVerification(token, options) {
        return LoginVerificationApiFp(this.configuration).otpInitLoginVerification(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify the code entered by the user.
     * @param {string} token Token
     * @param {LoginVerificationCode} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginVerificationApi
     */
    otpVerifyLoginVerification(token, body, options) {
        return LoginVerificationApiFp(this.configuration).otpVerifyLoginVerification(token, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send a verification code to the user\'s phone number.
     * @param {LoginVerificationToken} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginVerificationApi
     */
    sendLoginVerification(body, options) {
        return LoginVerificationApiFp(this.configuration).sendLoginVerification(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify the code entered by the user.
     * @param {string} token Token
     * @param {TfaVerifyWsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginVerificationApi
     */
    verifyLoginVerification(token, body, options) {
        return LoginVerificationApiFp(this.configuration).verifyLoginVerification(token, body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OneTimePasswordApiApi - axios parameter creator
 * @export
 */
export const OneTimePasswordApiApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get qr code and secret key of a verified user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTimePassword: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/restpublic/tech-web/otp/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Init One Time Password for a user.
         * @param {OneTimePasswordUserSettings} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOneTimePassword: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('initOneTimePassword', 'body', body);
            const localVarPath = `/restpublic/tech-web/otp/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {OneTimePasswordVerify} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOneTimePassword: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyOneTimePassword', 'body', body);
            const localVarPath = `/restpublic/tech-web/otp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OneTimePasswordApiApi - functional programming interface
 * @export
 */
export const OneTimePasswordApiApiFp = function (configuration) {
    const localVarAxiosParamCreator = OneTimePasswordApiApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get qr code and secret key of a verified user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTimePassword(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOneTimePassword(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Init One Time Password for a user.
         * @param {OneTimePasswordUserSettings} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOneTimePassword(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initOneTimePassword(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {OneTimePasswordVerify} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOneTimePassword(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyOneTimePassword(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OneTimePasswordApiApi - factory interface
 * @export
 */
export const OneTimePasswordApiApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OneTimePasswordApiApiFp(configuration);
    return {
        /**
         *
         * @summary Get qr code and secret key of a verified user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTimePassword(options) {
            return localVarFp.getOneTimePassword(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Init One Time Password for a user.
         * @param {OneTimePasswordUserSettings} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOneTimePassword(body, options) {
            return localVarFp.initOneTimePassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify the code entered by the user.
         * @param {OneTimePasswordVerify} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOneTimePassword(body, options) {
            return localVarFp.verifyOneTimePassword(body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OneTimePasswordApiApi - object-oriented interface
 * @export
 * @class OneTimePasswordApiApi
 * @extends {BaseAPI}
 */
export class OneTimePasswordApiApi extends BaseAPI {
    /**
     *
     * @summary Get qr code and secret key of a verified user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OneTimePasswordApiApi
     */
    getOneTimePassword(options) {
        return OneTimePasswordApiApiFp(this.configuration).getOneTimePassword(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Init One Time Password for a user.
     * @param {OneTimePasswordUserSettings} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OneTimePasswordApiApi
     */
    initOneTimePassword(body, options) {
        return OneTimePasswordApiApiFp(this.configuration).initOneTimePassword(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify the code entered by the user.
     * @param {OneTimePasswordVerify} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OneTimePasswordApiApi
     */
    verifyOneTimePassword(body, options) {
        return OneTimePasswordApiApiFp(this.configuration).verifyOneTimePassword(body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Send tracking partner ID to tech-ws for partner atribuation
         * @param {string} partnerId TopartnerIden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tracking: (partnerId_1, ...args_1) => __awaiter(this, [partnerId_1, ...args_1], void 0, function* (partnerId, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('tracking', 'partnerId', partnerId);
            const localVarPath = `/restpublic/tech-api/tracking/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function (configuration) {
    const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Send tracking partner ID to tech-ws for partner atribuation
         * @param {string} partnerId TopartnerIden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tracking(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tracking(partnerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TrackingApiFp(configuration);
    return {
        /**
         *
         * @summary Send tracking partner ID to tech-ws for partner atribuation
         * @param {string} partnerId TopartnerIden
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tracking(partnerId, options) {
            return localVarFp.tracking(partnerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
    /**
     *
     * @summary Send tracking partner ID to tech-ws for partner atribuation
     * @param {string} partnerId TopartnerIden
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    tracking(partnerId, options) {
        return TrackingApiFp(this.configuration).tracking(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TwoFactorAuthenticationApiApi - axios parameter creator
 * @export
 */
export const TwoFactorAuthenticationApiApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Init PSD2Web. Get channel and payout.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Web: (id_1, formType_1, ...args_1) => __awaiter(this, [id_1, formType_1, ...args_1], void 0, function* (id, formType, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInitPsd2Web', 'id', id);
            // verify required parameter 'formType' is not null or undefined
            assertParamExists('getInitPsd2Web', 'formType', formType);
            const localVarPath = `/restpublic/tech-web/psd2/tfa/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get call Enabled Country Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSetup: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/restpublic/tech-web/tfa/setup/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify PSD2 two factor authentication code
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeWeb: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('postVerifyPsd2CodeWeb', 'body', body);
            const localVarPath = `/restpublic/tech-web/psd2/tfa/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeWeb: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/restpublic/tech-web/tfa/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send PSD2Web code.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeWeb: (id_1, formType_1, ...args_1) => __awaiter(this, [id_1, formType_1, ...args_1], void 0, function* (id, formType, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendPSD2CodeWeb', 'id', id);
            // verify required parameter 'formType' is not null or undefined
            assertParamExists('sendPSD2CodeWeb', 'formType', formType);
            const localVarPath = `/restpublic/tech-web/psd2/tfa/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (formType !== undefined) {
                localVarQueryParameter['formType'] = formType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupWeb: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setupWeb', 'body', body);
            const localVarPath = `/restpublic/tech-web/tfa/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify two factor authentication code
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWeb: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyWeb', 'body', body);
            const localVarPath = `/restpublic/tech-web/tfa/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TwoFactorAuthenticationApiApi - functional programming interface
 * @export
 */
export const TwoFactorAuthenticationApiApiFp = function (configuration) {
    const localVarAxiosParamCreator = TwoFactorAuthenticationApiApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get Init PSD2Web. Get channel and payout.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Web(id, formType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInitPsd2Web(id, formType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get call Enabled Country Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSetup(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initSetup(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify PSD2 two factor authentication code
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeWeb(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postVerifyPsd2CodeWeb(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeWeb(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendCodeWeb(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send PSD2Web code.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeWeb(id, formType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendPSD2CodeWeb(id, formType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupWeb(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setupWeb(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify two factor authentication code
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWeb(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyWeb(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TwoFactorAuthenticationApiApi - factory interface
 * @export
 */
export const TwoFactorAuthenticationApiApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TwoFactorAuthenticationApiApiFp(configuration);
    return {
        /**
         *
         * @summary Get Init PSD2Web. Get channel and payout.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitPsd2Web(id, formType, options) {
            return localVarFp.getInitPsd2Web(id, formType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get call Enabled Country Codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSetup(options) {
            return localVarFp.initSetup(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify PSD2 two factor authentication code
         * @param {TfaVerifyRequestBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVerifyPsd2CodeWeb(body, options) {
            return localVarFp.postVerifyPsd2CodeWeb(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodeWeb(options) {
            return localVarFp.sendCodeWeb(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send PSD2Web code.
         * @param {number} id Payout Id
         * @param {string} formType Form Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPSD2CodeWeb(id, formType, options) {
            return localVarFp.sendPSD2CodeWeb(id, formType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Setup two factor authentication phone number for a user
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupWeb(body, options) {
            return localVarFp.setupWeb(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify two factor authentication code
         * @param {TfaSetupFrontRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWeb(body, options) {
            return localVarFp.verifyWeb(body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TwoFactorAuthenticationApiApi - object-oriented interface
 * @export
 * @class TwoFactorAuthenticationApiApi
 * @extends {BaseAPI}
 */
export class TwoFactorAuthenticationApiApi extends BaseAPI {
    /**
     *
     * @summary Get Init PSD2Web. Get channel and payout.
     * @param {number} id Payout Id
     * @param {string} formType Form Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    getInitPsd2Web(id, formType, options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).getInitPsd2Web(id, formType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get call Enabled Country Codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    initSetup(options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).initSetup(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify PSD2 two factor authentication code
     * @param {TfaVerifyRequestBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    postVerifyPsd2CodeWeb(body, options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).postVerifyPsd2CodeWeb(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Setup two factor authentication phone number for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    sendCodeWeb(options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).sendCodeWeb(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send PSD2Web code.
     * @param {number} id Payout Id
     * @param {string} formType Form Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    sendPSD2CodeWeb(id, formType, options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).sendPSD2CodeWeb(id, formType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Setup two factor authentication phone number for a user
     * @param {TfaSetupFrontRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    setupWeb(body, options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).setupWeb(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify two factor authentication code
     * @param {TfaSetupFrontRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationApiApi
     */
    verifyWeb(body, options) {
        return TwoFactorAuthenticationApiApiFp(this.configuration).verifyWeb(body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersCommonCanopyTechWsApi - axios parameter creator
 * @export
 */
export const UsersCommonCanopyTechWsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get countries of defined type with regions if any on canopy tech ws
         * @param {'ADDRESS' | 'BIRTH'} type Return birth or address countries
         * @param {'ISO' | 'ALPHA2'} [format] Return country code information according to determined format. ISO won\&#39;t be possible for type BIRTH. By default, ISO.
         * @param {boolean} [withRegions] Filter if we want to provide regions according to certain address countries. withRegions&#x3D;true won\&#39;t be possible for type BIRTH. By default, false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountries: (type_1, format_1, withRegions_1, ...args_1) => __awaiter(this, [type_1, format_1, withRegions_1, ...args_1], void 0, function* (type, format, withRegions, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getUserCountries', 'type', type);
            const localVarPath = `/restpublic/tech-web/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            if (withRegions !== undefined) {
                localVarQueryParameter['withRegions'] = withRegions;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersCommonCanopyTechWsApi - functional programming interface
 * @export
 */
export const UsersCommonCanopyTechWsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersCommonCanopyTechWsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get countries of defined type with regions if any on canopy tech ws
         * @param {'ADDRESS' | 'BIRTH'} type Return birth or address countries
         * @param {'ISO' | 'ALPHA2'} [format] Return country code information according to determined format. ISO won\&#39;t be possible for type BIRTH. By default, ISO.
         * @param {boolean} [withRegions] Filter if we want to provide regions according to certain address countries. withRegions&#x3D;true won\&#39;t be possible for type BIRTH. By default, false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountries(type, format, withRegions, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserCountries(type, format, withRegions, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersCommonCanopyTechWsApi - factory interface
 * @export
 */
export const UsersCommonCanopyTechWsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersCommonCanopyTechWsApiFp(configuration);
    return {
        /**
         *
         * @summary Get countries of defined type with regions if any on canopy tech ws
         * @param {'ADDRESS' | 'BIRTH'} type Return birth or address countries
         * @param {'ISO' | 'ALPHA2'} [format] Return country code information according to determined format. ISO won\&#39;t be possible for type BIRTH. By default, ISO.
         * @param {boolean} [withRegions] Filter if we want to provide regions according to certain address countries. withRegions&#x3D;true won\&#39;t be possible for type BIRTH. By default, false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountries(type, format, withRegions, options) {
            return localVarFp.getUserCountries(type, format, withRegions, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersCommonCanopyTechWsApi - object-oriented interface
 * @export
 * @class UsersCommonCanopyTechWsApi
 * @extends {BaseAPI}
 */
export class UsersCommonCanopyTechWsApi extends BaseAPI {
    /**
     *
     * @summary Get countries of defined type with regions if any on canopy tech ws
     * @param {'ADDRESS' | 'BIRTH'} type Return birth or address countries
     * @param {'ISO' | 'ALPHA2'} [format] Return country code information according to determined format. ISO won\&#39;t be possible for type BIRTH. By default, ISO.
     * @param {boolean} [withRegions] Filter if we want to provide regions according to certain address countries. withRegions&#x3D;true won\&#39;t be possible for type BIRTH. By default, false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersCommonCanopyTechWsApi
     */
    getUserCountries(type, format, withRegions, options) {
        return UsersCommonCanopyTechWsApiFp(this.configuration).getUserCountries(type, format, withRegions, options).then((request) => request(this.axios, this.basePath));
    }
}
